<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Counter:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'CountdownImage')"
            [blockData]="block.variables?.CountdownImage ?? ''"
            [placeholder]="countdownImagePlaceholder"
            variable="CountdownImage"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'CountdownLink')"
            [blockData]="block.variables?.CountdownLink ?? ''"
            [placeholder]="countdownLinkPlaceholder"
            variable="CountdownLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'CountdownLinkSegmentRegex')"
            [selectedSegment]="block.variables?.CountdownLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-6">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'CountdownAlt')"
            [blockData]="block.variables?.CountdownAlt ?? ''"
            [placeholder]="countdownAltPlaceholder"
            variable="CountdownAlt"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div ngbDropdown class="d-inline-block">
      <div ngbDropdownMenu aria-labelledby="dropdownForm1">
        <form class="px-4 py-3">
          <div class="mb-3">
            <label for="exampleDropdownFormEmail1">Send comment</label>
            <input
              type="email"
              class="form-control"
              id="exampleDropdownFormEmail1"
              placeholder="email@example.com"
              autocomplete="username"
            />
          </div>
          <button type="submit" class="btn btn-primary">Send</button>
        </form>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>

      <div class="right-side">
        <div class="row text-center">
          <div *ngIf="block.variables?.CountdownImage" class="row col-12">
            <!-- <a
              [href]="helper.getFullUrl(block.variables?.CountdownLink)"
              target="_blank"
            > -->
            <img
              [src]="$safeNavigationMigration(block.variables?.CountdownImage)"
              [alt]="$safeNavigationMigration(block.variables?.CountdownAlt)"
              class="img-fluid full-width-img"
            />
            <!-- </a> -->
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
